import React, { useEffect } from 'react';

export const IubendaScript = () => {
  useEffect(() => {
    // Load iubenda script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = `
      (function (w,d) {
        var loader = function () {
          var s = d.createElement("script"), 
              tag = d.getElementsByTagName("script")[0]; 
          s.src="https://cdn.iubenda.com/iubenda.js"; 
          tag.parentNode.insertBefore(s,tag);
        }; 
        if(w.addEventListener){
          w.addEventListener("load", loader, false);
        }else if(w.attachEvent){
          w.attachEvent("onload", loader);
        }else{
          w.onload = loader;
        }
      })(window, document);
    `;
    document.head.appendChild(script);

    return () => {
      // Cleanup
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
    // Empty deps: script is created inside effect, runs once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export const IubendaCookiePolicy = () => {
  return (
    <a 
      href="https://www.iubenda.com/privacy-policy/50449758/cookie-policy" 
      className="iubenda-white iubenda-noiframe iubenda-embed" 
      title="Cookie Policy"
    >
      Cookie Policy
    </a>
  );
};

export const IubendaPrivacyPolicy = () => {
  return (
    <a 
      href="https://www.iubenda.com/privacy-policy/50449758" 
      className="iubenda-white iubenda-noiframe iubenda-embed" 
      title="Privacy Policy"
    >
      Privacy Policy
    </a>
  );
};